var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M224.1 284.64l-56.89 56.78-154-154.31a24 24 0 0 1 0-33.94l22.65-22.7a23.93 23.93 0 0 1 33.84 0z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M435 187.15L241 381.48a23.94 23.94 0 0 1-33.84 0l-40-40 211.34-211a23.93 23.93 0 0 1 33.84 0L435 153.21a24 24 0 0 1 0 33.94z","className":"fa-primary","key":2})]);
}

ChevronDown.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
